import { useState } from 'react';
import { Outlet, useLoaderData } from 'react-router-dom';
import type { AdminMeResponse } from '@immo/api-contract';
import { SandboxBanner } from './sandbox-banner';
import { Sidebar } from './sidebar';
import { Topbar } from './topbar';
import type { AdminOutletContext } from './topbar-slots';

export function AdminLayout() {
  const me = useLoaderData() as AdminMeResponse;
  const [leadingEl, setLeadingEl] = useState<HTMLElement | null>(null);
  const [trailingEl, setTrailingEl] = useState<HTMLElement | null>(null);
  // Phone only. The layout owns it rather than the sidebar, because the control
  // that opens it lives in the topbar — two siblings, one piece of state.
  const [navOpen, setNavOpen] = useState(false);

  const context: AdminOutletContext = { me, leadingEl, trailingEl };

  return (
    <div className="flex h-screen flex-col bg-canvas text-text-primary">
      <SandboxBanner />
      <div className="flex min-h-0 flex-1">
        <Sidebar me={me} open={navOpen} onClose={() => setNavOpen(false)} />
        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar onLeadingRef={setLeadingEl} onTrailingRef={setTrailingEl} onMenuClick={() => setNavOpen(true)} />
          <main className="flex-1 overflow-y-auto bg-surface">
            <Outlet context={context} />
          </main>
        </div>
      </div>
    </div>
  );
}
